<div
  class="collapse navbar-collpase border-end h-100"
  [ngbCollapse]="collapsed()"
  [horizontal]="true"
  id="navbarSupportedContent">
  <ul class="nav navbar-nav ml-auto" style="width: 200px">
    <li class="nav-item">
      <a
        class="nav-link"
        (click)="goTo((loggedIn ? 'private/local/' : 'public/local/') + urlToken)">
        <i class="fa-solid fa-house me-2"></i>
        {{ 'HOME' | translate }}
      </a>
    </li>
    @if (loggedIn) {
      <li class="nav-item">
        <a class="nav-link" (click)="goTo('private/search')">
          <i class="fa-solid fa-utensils me-2"></i>
          {{ 'RESTAURANTS' | translate }}
        </a>
      </li>
    }
    @if (!!urlToken) {
      <li class="nav-item">
        <a
          class="nav-link"
          (click)="goTo((loggedIn ? 'private/local/' : 'public/local/') + urlToken)">
          <i class="fa-solid fa-bars me-2"></i>
          {{ 'RESTAURANT_MENU' | translate }}
        </a>
      </li>
    }
    @if (loggedIn) {
      <li class="nav-item">
        <a class="nav-link" (click)="goTo('private/orders')">
          <i class="fa-solid fa-clock-rotate-left me-2"></i>
          {{ 'ORDERS' | translate }}
        </a>
      </li>
    }
    @if (loggedIn) {
      <li class="nav-item">
        <a class="nav-link" (click)="goTo('private/profile')">
          <i class="fa-solid fa-user me-2"></i>
          {{ 'PROFILE' | translate }}
        </a>
      </li>
    }
    @if (!!urlToken) {
      <li class="nav-item">
        <a class="nav-link" (click)="share()">
          <i class="fa fa-share-alt me-2" aria-hidden="true"></i>
          {{ 'SHARE' | translate }}
        </a>
      </li>
    }
    <li class="nav-item">
      <a class="nav-link" (click)="goTo('languages')">
        <i class="fa-solid fa-language me-2"></i>
        {{ 'LANGUAGE' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" (click)="goTo('accesibility')">
        <i class="fa-solid fa-universal-access me-2"></i>
        {{ 'ACCESSIBILITY.TITLE' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" (click)="goTo('others')">
        <i class="fa-solid fa-plus me-2"></i>
        {{ 'OTHERS' | translate }}
      </a>
    </li>
    @if (!loggedIn) {
      <li class="nav-item">
        <a class="nav-link" (click)="login()">
          <i class="fa-solid fa-right-to-bracket me-2"></i>
          {{ 'LOGIN2' | translate }}
        </a>
      </li>
    }
    @if (loggedIn) {
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0)" (click)="signout()">
          <i class="fa-solid fa-right-from-bracket me-2"></i>
          {{ 'LOGOUT' | translate }}
        </a>
      </li>
    }
  </ul>
</div>
